import { getConfig } from "../config";

const _wsUrl = getConfig().wsUrl;
export const WEBSOCKETS_URL = _wsUrl?.endsWith("/") ? _wsUrl : _wsUrl + "/";

const CSRF_COOKIE_NAME = "cirrom_csrftoken";

const readCookie = (name: string): string | undefined => {
  const prefix = `${name}=`;
  return document.cookie
    .split(";")
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith(prefix))
    ?.substring(prefix.length);
};

// The websocket server requires the CSRF cookie echoed back as a query param.
const withCsrfToken = (url: string): string => {
  const token = readCookie(CSRF_COOKIE_NAME);
  if (!token) {
    return url;
  }
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}csrftoken=${encodeURIComponent(token)}`;
};

class WebSocketConnections {
  private static _availableConnections: any;
  static _instance: any;

  private constructor() {}

  public static getInstance() {
    if (!WebSocketConnections._instance) {
      this._availableConnections = {};
      WebSocketConnections._instance = this;
    }
    return WebSocketConnections._instance;
  }

  public static connect(websocketUrl) {
    if (
      !this._availableConnections[websocketUrl] ||
      this._availableConnections[websocketUrl].readyState === WebSocket.CLOSED
    ) {
      this._availableConnections[websocketUrl] = new WebSocket(websocketUrl);
    }
    return this._availableConnections[websocketUrl];
  }
}

export const getFilesWebSocketConnection = () => {
  return WebSocketConnections.getInstance().connect(
    withCsrfToken(`${WEBSOCKETS_URL}ws-files`)
  );
};

export const getBatchWebSocketConnection = () => {
  return WebSocketConnections.getInstance().connect(
    withCsrfToken(`${WEBSOCKETS_URL}ws-batches`)
  );
};

export const getSuggestedChangesWebSocketConnection = (batchId: number) => {
  return WebSocketConnections.getInstance().connect(
    withCsrfToken(`${WEBSOCKETS_URL}ws-suggested-changes/${batchId}`)
  );
};

export const getRuleEvaluationWebSocketConnection = (
  batchId: number,
  ruleId: number
) => {
  return new WebSocket(
    withCsrfToken(`${WEBSOCKETS_URL}ws-rule-evaluation/${batchId}/${ruleId}`)
  );
};

export const getListManagementWebSocketConnection = (batchGroupId: number) => {
  return new WebSocket(
    withCsrfToken(`${WEBSOCKETS_URL}ws-list-management/${batchGroupId}`)
  );
};
